import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import './mention-card-date.scss';

applyTranslations(require('./mention-card-date.i18n.json'));

type Props = {
  date: string | undefined
};

const MentionCardDate = ({
  date
}: Props) => {
  if (isEmpty(date)) {
    return null;
  }

  const formattedDate = getDisplayDate(date);
  const tooltip = `${__t('mention_card_date.label')}: ${formattedDate}`;

  return (
    <div
      title={tooltip}
      className="mention-card-date"
    >
      <div
        className="mention-card-date__icon"
        title={tooltip}
      >
        <SVGDynamicIcon
          name="calendar-custom-fg"
          width={16}
          height={16}
          customColor="grey"
        />
      </div>
      <div>
        {formattedDate}
      </div>
    </div>
  );
};

export default MentionCardDate;
